exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-de9260d6], .fade-leave-active[data-v-de9260d6] {\n    -webkit-transition: all 0.5s;\n    transition: all 0.5s;\n}\n.fade-enter[data-v-de9260d6], .fade-leave-to[data-v-de9260d6] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\n", ""]);

// exports
